// NOTE: Dependencies: jQuery

(function ($) {
	$.fn.lmFeaturedVideos = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			playingIdValue: 'playing',
			playingId: '#playing',
			wrapper: '#featuredVideos',
			textSelector: 'feature-heading--small',
			addedSelector: 'feature-heading--light',
			thumbTagString: 'image-card__thumb">'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};
		
		var	_currentVideoId = $('[data-current-bcvid]:first').data('current-bcvid'),
			$playingItem = $('[data-bcvid="'+ _currentVideoId +'"]').parent(),
			$wrapper = $(settings.wrapper),
			featuredMarkUp = '';

		if (!$playingItem.length) {
			$wrapper.closest('.panel-dark.panel-dark--featured').remove();
			return false;
		}

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			// Generate mark-up from existing Items.
			featuredMarkUp += $playingItem[0].outerHTML.replace(settings.thumbTagString,settings.thumbTagString + '<span class="image-card__notice">Now Playing</span>');

			if ($playingItem.next().length > 0) {
				featuredMarkUp += $playingItem.next()[0].outerHTML.replace(settings.thumbTagString,settings.thumbTagString + '<span class="image-card__notice">Up Next</span>');
			}

			if ($playingItem.nextAll().eq(1).length > 0) {
				featuredMarkUp += $playingItem.nextAll().eq(1)[0].outerHTML;
			}

			if ($playingItem.nextAll().eq(2).length > 0) {
				featuredMarkUp += $playingItem.nextAll().eq(2)[0].outerHTML;
			}

			// Replace some selectors.
			featuredMarkUp = featuredMarkUp.replace(` id="${settings.playingIdValue}"`,'').replace(new RegExp(settings.textSelector, 'g'), `${settings.textSelector} ${settings.addedSelector}`);
			
			// Add the mark-up to the page.
			$wrapper.append(featuredMarkUp);
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));